/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: toUUID.js
 *
 * Created by robertcaslin.
 */
export default function toUUID(layerIdentifier) {
    return layerIdentifier.replace(/^layer:\/\/\/.+\//, '');
}


// WEBPACK FOOTER //
// ./src/utils/toUUID.js